import { render } from "./ProspectOpeningHoursAlt.vue?vue&type=template&id=6239a2a5"
import script from "./ProspectOpeningHoursAlt.vue?vue&type=script&lang=js"
export * from "./ProspectOpeningHoursAlt.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__